import axios from "axios";
import { handleRequestError, memoizePromiseFn } from "../../requests";

export const recalcInvoice = async (invoice) => {
  const results = await axios.post(`/GasBilling/RecalcInvoice`, invoice).catch(handleRequestError);
  return results.data;
};

export const getGasRecentDeliveries = async (customerId) => {
  const results = await axios.get(`/GasBilling/GetGasRecentDeliveries/${customerId}`).catch(handleRequestError);
  return results.data;
}

export const getGasInvoice = async (trackingid) => {
  const results = await axios.get(`/GasBilling/GetGasInvoice/${trackingid}`).catch(handleRequestError);
  return results.data;
}
export const getGasInvoiceForOrder = async (trackingid) => {
  // The originating order (and its on-page delivery type) ride on the create page URL, set by the order Billing tab link.
  const search = new URLSearchParams(window.location.search);
  const params: any = {};
  if (search.get('orderId')) params.orderId = search.get('orderId');
  if (search.get('deliveryTypeId')) params.deliveryTypeId = search.get('deliveryTypeId');
  const results = await axios.get(`/GasBilling/GetGasInvoiceForOrder/${trackingid}`, { params }).catch(handleRequestError);
  return results.data;
}

const plantParams = (orderId?, deliveryTypeId?) => ({
  ...(orderId ? { orderId } : {}),
  ...(deliveryTypeId ? { deliveryTypeId } : {}),
});

// Legacy "Use Plant Volumes (Starting)/(Ending)" buttons on the "Add Gas Billing
// Entry" modal — pull the plant readings for the order's tracking on demand.
export const getGasPlantVolumesStarting = async (trackingId, orderId?, deliveryTypeId?) => {
  const results = await axios.get(`/GasBilling/GetGasPlantVolumesStarting/${trackingId}`, { params: plantParams(orderId, deliveryTypeId) }).catch(handleRequestError);
  return results.data;
}
export const getGasPlantVolumesEnding = async (trackingId, orderId?, deliveryTypeId?) => {
  const results = await axios.get(`/GasBilling/GetGasPlantVolumesEnding/${trackingId}`, { params: plantParams(orderId, deliveryTypeId) }).catch(handleRequestError);
  return results.data;
}
// Legacy modal Trailer In (all active) / Trailer Out (customer on-site, or all with "View All") lists.
export const getGasTrailerOptions = async (trackingId, orderId, customerOnSite: boolean) => {
  const results = await axios.get(`/GasBilling/GetGasTrailerOptions/${trackingId}`, { params: { ...(orderId ? { orderId } : {}), customerOnSite } }).catch(handleRequestError);
  return results?.data ?? [];
}
// Legacy TrailerChange — container defaults (water volume + tube count) applied to
// the invoice contents when a container dropdown changes.
export const getGasContainerTrailer = async (containerId) => {
  const results = await axios.get(`/GasBilling/GetGasContainerTrailer/${encodeURIComponent(containerId)}`).catch(handleRequestError);
  return results?.data;
}
export const InsertBilling = async (billing) => {
  const results = await axios.post('/GasBilling/InsertBilling', billing).catch(handleRequestError);
  return results.data;
}
export const InsertBillingForOrder = async (billing) => {
  const results = await axios.post('/GasBilling/InsertBillingForOrder', billing).catch((error) => {
    // Legacy modal showed its validation as "Error: ..." and stayed open.
    if (error?.response?.status === 400 && typeof error.response.data === 'string') alert(error.response.data);
    return handleRequestError(error);
  });
  return results.data;
}

export const getGasInvoices = async (queryDefinition) => {
  const results = await axios.post(`/GasBilling/GetBillingList`, queryDefinition).catch(handleRequestError);
  return results.data;
}
export const getGasPendingDeliveries = async (cst) => {
  const results = await axios.get(`/GasBilling/getGasPendingDeliveries`).catch(handleRequestError);
  return results.data;
}

export const deleteInvoice = async (invoiceId) => {
  const results = await axios.delete(`/GasBilling/DeleteInvoice/${invoiceId}`).catch(handleRequestError);
  return results.data;
};
// /PreAuthorizeCreditCard
export const PreAuthorizeCreditCard = async (billingId) => {
  const results = await axios.get(`/GasBilling/PreAuthorizeCreditCard/${billingId}`).catch(handleRequestError);
  return results.data;
};

export const getBillingHeader = async (billingId) => {
  const results = await axios.get(`/GasBilling/getBillingHeader/${billingId}`).catch(handleRequestError);
  return results.data;
};

export const reverseBilling = async (reverse) => {
  const results = await axios.post(`/GasBilling/reverseBilling`, reverse).catch(handleRequestError);
  return results.data;
};

export const uploadInvoicesJDEDTO = async (invoice) => {
  const results = await axios.post(`/GasBilling/UploadInvoicesToJDE`, invoice).catch(handleRequestError);
  return results.data;
};

export const SendReport = async (report) => {
  const results = await axios.post('/GasBilling/SendReport', report).catch(handleRequestError);
  return results.data;
};
export const downloadReport = async (report) => {
  const results = await axios.post('/GasBilling/DownloadReport', report, { responseType: 'blob' }).catch(handleRequestError);

  const url = window.URL.createObjectURL(new Blob([results.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', report.filename);
  document.body.appendChild(link);
  link.click();
};
export const GetJDEErrors = async (billing) => {
  const results = await axios.get('/GasBilling/GetJDEErrors').catch(handleRequestError);
  return results.data;
}
export const GetUnbilledInvoices = async (billing) => {
  const results = await axios.get('/GasBilling/GetUnbilledInvoices').catch(handleRequestError);
  return results.data;
}

export const UpdateBilling = async (billing) => {
  const results = await axios.put('/GasBilling/UpdateBilling', billing).catch(handleRequestError);
  return results.data;
}